export const discountCalculator = (type, actualAmount, offerAmount) => {
  // eslint-disable-next-line default-case
  switch (type) {
    case "percentage":
      return percentDiscount(actualAmount, offerAmount);
    case "flat":
      return flatDiscount(actualAmount, offerAmount);
  }
};

const percentDiscount = (actualAmount, offerAmount) => {
  return (actualAmount * offerAmount) / 100;
};

const flatDiscount = (actualAmount, offerAmount) => {
  return offerAmount;
};

export const handleOutletName = (name) => {
  const outlet = name.split(" ");
  const outletName = outlet.slice(0, 2).join(" ");
  return outletName;
};

export const handleExploreOutletName = (name) => {
  const outlet = name.split(" ");
  const outletName = outlet.slice(0, 4).join(" ");
  return outletName;
};

export const handlePaybillOutletName = (name) => {
  const outlet = name.split(" ");
  const outletName = outlet.slice(0, 3).join(" ");
  return outletName;
};
